import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import D3EFeature from "../models/D3EFeature";
import TextView from "./TextView";
import { BuildContext } from "../classes/BuildContext";

type _AppFeatureCardViewOnReviewFeature = (feature: D3EFeature) => void;

export interface AppFeatureCardViewProps extends BaseUIProps {
  key?: string;
  obj: D3EFeature;
  isMobileSrc: boolean;
  onReviewFeature?: _AppFeatureCardViewOnReviewFeature;
}

class _AppFeatureCardViewState extends ObservableComponent<AppFeatureCardViewProps> {
  static defaultProps = {
    obj: null,
    isMobileSrc: false,
    onReviewFeature: null,
  };
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: AppFeatureCardViewProps) {
    super(props);

    this.initState();
  }
  public get obj(): D3EFeature {
    return this.props.obj;
  }
  public get isMobileSrc(): boolean {
    return this.props.isMobileSrc;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.updateSyncProperty("obj", this.props.obj);

    this.on(
      [
        "isMobileSrc",
        "obj",
        "obj.androidScreenshot",
        "obj.bundle",
        "obj.bundle.title",
        "obj.title",
        "obj.webScreenshot",
      ],
      this.rebuild
    );
  }
  public componentDidUpdate(prevProps: AppFeatureCardViewProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.obj !== this.props.obj) {
      this.updateObservable("obj", prevProps.obj, this.props.obj);

      this.fire("obj", this);
    }

    if (prevProps.isMobileSrc !== this.props.isMobileSrc) {
      this.fire("isMobileSrc", this);
    }
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Row({
      children: [
        ui.Column({
          children: [
            ui.Container({
              clipBehavior: ui.Clip.hardEdge,
              child: ui.NetworkImage({
                url: this.isMobileSrc
                  ? this.obj.androidScreenshot?.downloadUrl ?? ""
                  : this.obj.webScreenshot?.downloadUrl ?? "",
                fit: ui.BoxFit.contain,
                className: "hc vc",
              }),
              className: "xab hc vc",
              key: "0",
            }),
          ],
          className: "x4b vc v",
          key: "0",
        }),
        ui.Column({
          crossAxisAlignment: ui.CrossAxisAlignment.start,
          children: [
            TextView({
              data: this.obj.title,
              style: new ui.TextStyle({ fontWeight: ui.FontWeight.w600 }),
              className: "xae",
              key: "0",
            }),
            TextView({
              data: this.obj.bundle !== null ? this.obj.bundle.title : "",
              textAlign: cStyle.tTextViewLabelTextAlignOn,
              style: new ui.TextStyle({ color: cStyle.tTextViewLabelColorOn }),
              className: "xed",
              key: "1",
            }),
          ],
          className: "xc6 vc v",
          key: "1",
        }),
      ],
      onTap: (e) => {
        e.stopPropagation();

        this.onShowWorkFlow();
      },
      className: ui.join(this.props.className, "AppFeatureCardView x45 hc vc"),
      ...copyBaseUIProps(this.props),
    });
  }
  public onShowWorkFlow = (): void => {
    this.onReviewFeature(this.obj);
  };
  public get onReviewFeature(): _AppFeatureCardViewOnReviewFeature {
    return this.props.onReviewFeature;
  }
}
export default function AppFeatureCardView(props: AppFeatureCardViewProps) {
  return React.createElement(_AppFeatureCardViewState, {
    ..._AppFeatureCardViewState.defaultProps,
    ...props,
  });
}
